import { render, staticRenderFns } from "./Airport.vue?vue&type=template&id=488978c6"
import script from "./Airport.vue?vue&type=script&lang=js"
export * from "./Airport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports